/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ObjectImportTask
 */
export interface ObjectImportTask {
  /**
   *
   * @type {string}
   * @memberof ObjectImportTask
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof ObjectImportTask
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof ObjectImportTask
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof ObjectImportTask
   */
  broId: string;
  /**
   *
   * @type {ObjectImportTaskBroDomainEnum}
   * @memberof ObjectImportTask
   */
  readonly broDomain?: ObjectImportTaskBroDomainEnum;
  /**
   * When True, skip the PDOK freshness check and always re-import.
   * @type {boolean}
   * @memberof ObjectImportTask
   */
  force?: boolean;
  /**
   *
   * @type {ObjectImportTaskStatusEnum}
   * @memberof ObjectImportTask
   */
  readonly status?: ObjectImportTaskStatusEnum;
  /**
   *
   * @type {string}
   * @memberof ObjectImportTask
   */
  readonly log?: string;
  /**
   *
   * @type {string}
   * @memberof ObjectImportTask
   */
  readonly dataOwner?: string | null;
}

/**
 * @export
 */
export const ObjectImportTaskBroDomainEnum = {
  Gmn: "GMN",
  Gmw: "GMW",
  Gld: "GLD",
  Frd: "FRD",
  Gar: "GAR",
  Cpt: "CPT",
  Bhr: "BHR",
  Guf: "GUF",
  Gpd: "GPD",
} as const;
export type ObjectImportTaskBroDomainEnum =
  (typeof ObjectImportTaskBroDomainEnum)[keyof typeof ObjectImportTaskBroDomainEnum];

/**
 * @export
 */
export const ObjectImportTaskStatusEnum = {
  Pending: "PENDING",
  Processing: "PROCESSING",
  Completed: "COMPLETED",
  Failed: "FAILED",
  Unfinished: "UNFINISHED",
} as const;
export type ObjectImportTaskStatusEnum =
  (typeof ObjectImportTaskStatusEnum)[keyof typeof ObjectImportTaskStatusEnum];

/**
 * Check if a given object implements the ObjectImportTask interface.
 */
export function instanceOfObjectImportTask(value: object): value is ObjectImportTask {
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  return true;
}

export function ObjectImportTaskFromJSON(json: any): ObjectImportTask {
  return ObjectImportTaskFromJSONTyped(json, false);
}

export function ObjectImportTaskFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ObjectImportTask {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    broId: json["bro_id"],
    broDomain: json["bro_domain"] == null ? undefined : json["bro_domain"],
    force: json["force"] == null ? undefined : json["force"],
    status: json["status"] == null ? undefined : json["status"],
    log: json["log"] == null ? undefined : json["log"],
    dataOwner:
      json["data_owner"] === undefined
        ? undefined
        : json["data_owner"] === null
        ? null
        : json["data_owner"],
  };
}

export function ObjectImportTaskToJSON(json: any): ObjectImportTask {
  return ObjectImportTaskToJSONTyped(json, false);
}

export function ObjectImportTaskToJSONTyped(
  value?: Omit<
    ObjectImportTask,
    "uuid" | "created" | "updated" | "bro_domain" | "status" | "log" | "data_owner"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    bro_id: value["broId"],
    force: value["force"],
  };
}
